import React from 'react';

const HeaderCartIcon = () => {
    return (
        <svg className="sidebar-cart-icon" xmlns="http://www.w3.org/2000/svg" width="19.988" height="19.988"
            viewBox="0 0 19.988 19.988">
            <g id="trolley-cart" transform="translate(-1 -1)">
                <path id="Path_36" data-name="Path 36"
                    d="M1.666,2.333H3.8L6.159,12.344a1.993,1.993,0,0,0,.171,3.98H17.656a.666.666,0,1,0,0-1.333H6.33a.666.666,0,0,1,0-1.333H17.578a1.992,1.992,0,0,0,1.945-1.541l1.412-6a2,2,0,0,0-1.946-2.456H5.486L4.98,1.514A.666.666,0,0,0,4.331,1H1.666a.666.666,0,0,0,0,1.333ZM18.989,5a.677.677,0,0,1,.649.819l-1.412,6a.662.662,0,0,1-.648.514H7.524L5.8,5Z"
                    transform="translate(0 0)" fill="#141517" />
                <path id="Path_37" data-name="Path 37"
                    d="M20,27a2,2,0,1,0,2-2A2,2,0,0,0,20,27Zm2.665,0A.666.666,0,1,1,22,26.333.666.666,0,0,1,22.665,27Z"
                    transform="translate(-6.341 -8.01)" fill="#141517" />
                <path id="Path_38" data-name="Path 38"
                    d="M9,27a2,2,0,1,0,2-2A2,2,0,0,0,9,27Zm2.665,0A.666.666,0,1,1,11,26.333.666.666,0,0,1,11.665,27Z"
                    transform="translate(-2.67 -8.01)" fill="#141517" />
            </g>
        </svg>
    );
};

export default HeaderCartIcon;